// tslint:disable:no-commented-code
// tslint:disable:no-duplicate-string
// tslint:disable:only-arrow-functions
// tslint:disable:no-big-function

import { recommendationsPanelsLocaleKeys } from '@epicuro-next/constants/features/localization';
import { IDynamicItem } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { mergeMultipleConfigs } from '@epicuro-next/platform/dynamic-components-utils';

import { createInstanceWithChildren } from '../../../../utils/dynamic-items-utils';
import { ScrollableRecommendationPanelBuilder } from '../../../builders/scrollable-recommendation-panel-builder';
import { SeeMoreSearchByUrl } from '../../../components/see-more-search-by-url';
import { DEFAULT_ROOT_PROPERTIES } from '../../../properties/default-root-properties';
import { DEFAULT_ROOT_STYLES } from '../../../properties/default-root-styles';
import { PANEL_STYLING_PROPERTIES } from '../../../properties/panel-styling-properties';
import { PANEL_TRACKING_PROPERTIES } from '../../../properties/panel-tracking-properties';
import { PRODUCT_ITEM_VIEW_PROPERTIES } from '../../../properties/product-item-view-properties';
import { SEARCH_PROVIDER_PROPERTIES } from '../../../properties/search-provider-properties';
import { SEE_MORE_LINK_PROPERTIES } from '../../../properties/see-more-link-properties';
import { SHOW_PANEL } from '../../../properties/show-panel-property';
import { LoadableItemView } from '../../../types/item-view';
import { productCard } from '../../../views/product-card';
import { SCROLLABLE_PANEL_PROPERTIES } from '../../../properties/scrollable-panel-properties';

type DisplayType = 'default' | 'p-card';
const defaultDisplayType: DisplayType = 'default';
type SingleItemViews = {
  default: LoadableItemView;
  pcard: LoadableItemView;
};

export function createHorizontalScrollablePanelPBasketSearch() {
  const root = createInstanceWithChildren({
    id: 'root',
    contentTypeId: 'dynamic-collections-renderer',
    data: {
      ...DEFAULT_ROOT_PROPERTIES,
      ...SCROLLABLE_PANEL_PROPERTIES,
      ...PANEL_TRACKING_PROPERTIES,
      ...PANEL_STYLING_PROPERTIES,
      ...SEE_MORE_LINK_PROPERTIES,
      ...SEARCH_PROVIDER_PROPERTIES,
      ...PRODUCT_ITEM_VIEW_PROPERTIES,
      headerText: recommendationsPanelsLocaleKeys.productSearchPanelHeaderText,
      panelName: 'horizontal-scrollable-panel-p-basket-search',
      panelTrackingId: 'HPMLPSEPC', // Horizontal Panel Manual Landin Page Search P Card
      displayType: defaultDisplayType,
      singleItemViews: {} as SingleItemViews,
      noItemsText: recommendationsPanelsLocaleKeys.noProductsFoundBySearchQuery,
      seeMoreLinkResolved: {
        values: [
          {
            provider: 'id:root',
            property: 'searchUrl',
          },
          {
            provider: 'GlobalStoreProviderService',
            property: {
              path: 'router.state.url',
            },
            filter: function (path: string | null | undefined): boolean {
              return (
                path !== undefined && path !== null && typeof path === 'string'
              );
            }.toString(),
            transform: function (url: string): string {
              return url;
            }.toString(),
          },
          {
            provider: 'id:root',
            property: 'seeMoreLink',
          },
        ],
        transform: function ([searchUrlStr, currentPath, seeMoreLink]: [
          string,
          string,
          string,
        ]): string {
          if (seeMoreLink) {
            searchUrlStr = seeMoreLink;
          }
          const currentUrl = new URL(location.href);
          const searchUrl = new URL(searchUrlStr);
          let route = `${searchUrl.pathname}${searchUrl.search}`;
          const defaultRootPath = currentUrl.pathname.replace(currentPath, '');
          if (route.startsWith(defaultRootPath)) {
            route = route.replace(defaultRootPath, '');
          }
          return route;
        }.toString(),
      },
      ...SHOW_PANEL,
    },
    styles: {
      ...DEFAULT_ROOT_STYLES,
      classes: ['horizontal-scrollable-panel-p-basket-search'],
    },
    children: [],
  });

  const horizontalScrollablePanelRecommendationPanelElementsBuilder =
    new ScrollableRecommendationPanelBuilder();

  const horizontalScrollablePanelRecommendationPanelElements =
    horizontalScrollablePanelRecommendationPanelElementsBuilder.build();

  const panelWithOverwrittenProperties = mergeMultipleConfigs(
    horizontalScrollablePanelRecommendationPanelElements.scrollablePanel,
    [
      {
        id: 'footer-container',
        if: ['EQ', [true, true]],
        children: [SeeMoreSearchByUrl],
      },
      {
        id: 'loading-skeletons-array-renderer',
        inputs: {
          contentType: productCard().loadingSkeletonContentType,
        },
      },
      {
        id: 'items-array-renderer',
        inputs: {
          contentType: productCard().itemContentType,
        },
      },
    ],
  ) as IDynamicItem[];

  root.children.push(panelWithOverwrittenProperties[0]);

  return { root };
}

export const horizontalScrollablePanelPBasketSearch =
  createHorizontalScrollablePanelPBasketSearch().root;
